import {CommonsService} from "@core/service/commons.service";
import {NgForm} from "@angular/forms";
import {SupInviteService} from "./sup-invite.service";
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'sup-invite-button',
  templateUrl: './supplier-invite-button.component.html',
  styles: []
})
export class SupplierInviteButtonComponent implements OnInit {
  ngOnInit():void {
  }

  constructor(private commonsService:CommonsService, private supInviteService:SupInviteService) {

  }

  //供应商邀请
  public supInvite = {};
  public inviteVisable:boolean = false;
  @Input() nzType='default';
  @Output() private sendSuccess = new EventEmitter();
  openInvite(form:NgForm) {
    form.reset();
    this.supInvite = {};
    this.inviteVisable = true;
  }

  closeInvite() {
    this.inviteVisable = false;
  }

  loading = false;

  modalOk(form:NgForm) {
    if (this.commonsService.validate(form)) {
      this.loading = true;
      this.supInviteService.update(this.supInvite).subscribe((data)=> {
        if (data) {
          this.commonsService.showSuccessMessage("shared.supplier-invite-button.inviteEmail");
          this.inviteVisable = false;
          this.sendSuccess.emit();
        }
        this.loading = false;
      }, ()=> {
        this.loading = true;
      })
    }
  }

}
